import script from "./DragCarrousel.vue?vue&type=script&setup=true&lang=js"
export * from "./DragCarrousel.vue?vue&type=script&setup=true&lang=js"

import "./DragCarrousel.vue?vue&type=style&index=0&id=0b27a6c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b27a6c4"]])

export default __exports__